import { api } from './api';

export type ActionStatus = 'pending' | 'accepted' | 'rejected' | 'completed';

export interface SessionAction {
  actionId: string;
  sessionId: string;
  text: string;
  assignee: string | null;
  status: ActionStatus;
  confidence: number;
  sourceText: string;
  detectedAt: string;
  updatedAt: string;
  transcriptEntryId?: string;
}

export async function getActions(sessionId: string): Promise<SessionAction[]> {
  const res = await api.get<{ actions: SessionAction[] }>(`/api/sessions/${sessionId}/actions`);
  return res.data.actions;
}

export async function updateActionStatus(
  sessionId: string,
  actionId: string,
  status: ActionStatus
): Promise<void> {
  await api.patch(`/api/sessions/${sessionId}/actions/${actionId}`, { status });
}
